/**
 * Multi-step scripts for the avatar (walk somewhere, play, leave through the door...).
 * The client's director runs them step by step.
 */
export type Step =
  | { walk: string | number; anim?: string }
  | { play: string; ms: number }
  | { door: "open" | "close" }
  | { hide: true }
  | { show: string }
  | { wait: number }
  | { place: true };

export const SEQUENCES: Record<string, readonly Step[]> = {
  trash_out: [
    { walk: "bags" },
    { play: "pick_up", ms: 900 },
    { walk: "door", anim: "walk_bag" },
    { door: "open" },
    { play: "exit_door", ms: 900 },
    { hide: true },
    { wait: 4000 },
    { show: "door" },
    { play: "enter_door", ms: 900 },
    { door: "close" },
    { walk: "center" },
    { play: "nod", ms: 1500 },
  ],
  shop_return: [
    { walk: "door" },
    { door: "open" },
    { play: "exit_door", ms: 900 },
    { hide: true },
    { wait: 4000 },
    { show: "door" },
    { play: "enter_door", ms: 600 },
    { door: "close" },
    { walk: "fridge", anim: "walk_shopping" },
    { play: "pick_up", ms: 1200 },
    { walk: "center" },
  ],
  new_item: [
    { walk: "door" },
    { door: "open" },
    { play: "exit_door", ms: 900 },
    { hide: true },
    { wait: 2500 },
    { show: "door" },
    { door: "close" },
    { walk: "item", anim: "carry_box" },
    { play: "pick_up", ms: 900 },
    { place: true },
    { play: "celebrate", ms: 1800 },
  ],
  leave: [
    { walk: "door" },
    { door: "open" },
    { play: "exit_door", ms: 1200 },
    { hide: true },
    { door: "close" },
  ],
  arrive: [
    { door: "open" },
    { show: "door" },
    { play: "enter_door", ms: 1200 },
    { door: "close" },
    { walk: "center" },
    { play: "nod", ms: 1200 },
  ],
};
